const LesdagStartTijd = "08:00:00"
const LesdagEindTijd = "17:00:00"

export default {
    LESDAGSTARTTIJD: LesdagStartTijd,
    LESDAGEINDTIJD: LesdagEindTijd,
}